<template>
  <v-row dense no-gutters>
    <v-col cols="8">
      <ref-properties-table :value="selectedProp" @input="onPropChange"/>
    </v-col>
    <v-col cols="4">
      <ref-prop-card :prop="selectedProp.length ? selectedProp[0] : {}" mode="viewer"/>
    </v-col>
    <ref-add-prop-dialog :prop="selectedProp.length ? selectedProp[0] : {}" v-model="showAddPropDialog" @propAdded="onPropAdded" @propUpdate="onPropUpdated"/>
    <sys-confirm-dialog :value="showDelConfirmDialog" :message="'Подтвердите удаление'" :no-call-back="cancelConfirmDialog" :ok-call-back="doDeleteProp"/>
  </v-row>
</template>

<script>
import { UI_ADD_ACTION, UI_SET_ACTIONS, UI_SNACKBAR } from '@/store/actions/ui'
import RefPropertiesTable from '@/components/modules/references/refPropertiesTable'
import RefPropCard from '@/components/modules/references/cards/refPropCard'
import RefAddPropDialog from '@/components/modules/references/dialogs/refAddPropDialog'
import SysConfirmDialog from '@/components/common/dialogs/confirmDialog'
import axios from 'axios'
export default {
  name: 'refOrgPropertiesList',
  props: ['accessKey'],
  components: { SysConfirmDialog, RefAddPropDialog, RefPropCard, RefPropertiesTable },
  data () {
    return {
      addAction: { text: 'Добавить свойство', actionType: 'Физ-хим свойства', action: 'addProp', method: this.addProp, icon: 'mdi-database-plus' },
      updAction: { text: 'Редактировать свойство', actionType: 'Физ-хим свойства', action: 'updProp', method: this.updateProp, icon: 'mdi-database-edit' },
      delAction: { text: 'Удалить свойство', actionType: 'Физ-хим свойства', action: 'delProp', method: this.delProp, icon: 'mdi-database-minus' },
      selectedProp: [],
      showAddPropDialog: false,
      showDelConfirmDialog: false
    }
  },
  watch: {
    accessKey (val) {
      console.log('Called for accessKey ', val)
      if (val !== 'forms/refComponentsList') {
        this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Физ-хим свойства' })
      } else {
        this.setActions()
      }
    }
  },
  methods: {
    setActions () {
      this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Физ-хим свойства' })
      this.$store.dispatch(UI_ADD_ACTION, this.addAction)
      if (this.selectedProp.length) {
        this.$store.dispatch(UI_ADD_ACTION, this.updAction)
        this.$store.dispatch(UI_ADD_ACTION, this.delAction)
      }
    },
    addProp () {
      this.selectedProp.splice(0, 1)
      this.showAddPropDialog = true
    },
    updateProp () {
      this.showAddPropDialog = true
    },
    delProp () {
      this.showDelConfirmDialog = true
    },
    cancelConfirmDialog () {
      this.showDelConfirmDialog = false
    },
    doDeleteProp () {
      console.log('Closing confirm dialog')
      this.showDelConfirmDialog = false
      const processorPath = '/api/org/references/delProperty.php'
      const payload = { ...this.selectedProp[0] }
      axios({
        url: processorPath,
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            this.selectedProp.splice(0, 1, { action: 'delete', PROP_ID: this.selectedProp[0].PROP_ID })
          } else {
            this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${err}` })
        })
    },
    onPropChange (item) {
      this.selectedProp.splice(0, 1, ...item)
      this.setActions()
    },
    onPropAdded (data) {
      this.onPropChange(data)
      this.showAddPropDialog = false
    },
    onPropUpdated (data) {
      this.onPropChange(data)
      this.showAddPropDialog = false
    }
  },

  mounted () {
    console.log('Local PCP module mounted')
    this.setActions()
  }
}
</script>
